import type { RecruiterFeeType } from '@/types/recruiter';

/** Maps recruiter fee / compensation type values to COMPENSATION_TYPE_* i18n keys. */
export function getCompensationTypeTranslationKey(
  type: string | undefined,
): string | null {
  if (!type) return null;
  switch (type) {
    case 'percentage':
      return 'COMPENSATION_TYPE_PERCENTAGE';
    case 'fixed':
      return 'COMPENSATION_TYPE_FIXED';
    case 'up to':
      return 'COMPENSATION_TYPE_UP_TO';
    case 'custom':
      return 'COMPENSATION_TYPE_CUSTOM';
    default:
      return null;
  }
}

/**
 * Maps recruiter fee_type API values to FEE_TYPE_* i18n keys.
 * Do not interpolate with toUpperCase — API value "up to" becomes invalid "FEE_TYPE_UP TO".
 */
export function getFeeTypeTranslationKey(
  type: string | undefined | null,
): string | null {
  if (!type) return null;
  switch (type) {
    case 'percentage':
      return 'FEE_TYPE_PERCENTAGE';
    case 'fixed':
      return 'FEE_TYPE_FIXED';
    case 'up to':
      return 'FEE_TYPE_UP_TO';
    case 'custom':
      return 'FEE_TYPE_CUSTOM';
    default:
      return null;
  }
}

export const compensationTypeLabelKeys: Record<RecruiterFeeType, string> = {
  percentage: 'COMPENSATION_TYPE_PERCENTAGE',
  fixed: 'COMPENSATION_TYPE_FIXED',
  'up to': 'COMPENSATION_TYPE_UP_TO',
  custom: 'COMPENSATION_TYPE_CUSTOM',
};
